import { FC } from "react";
import { MessageThread } from "../../../core/types";
import CaretRightIcon from "../../../components/icons/CaretRightIcon";
import { useTranslation } from "../../../contexts/useTranslation";

interface ChatListItemProps {
  bordered: boolean;
  messageThread: MessageThread;
  onClick: (messageThread: MessageThread) => void;
}

const ChatListItem: FC<ChatListItemProps> = ({ bordered, messageThread, onClick }) => {
  const { translate } = useTranslation();

  const formatSenderInitials = (): string => {
    if (messageThread.assigned_user?.first_name) {
      return messageThread.assigned_user.first_name.charAt(0);
    }
    return "AI";
  };

  const formatSenderName = (): string => {
    if (messageThread.assigned_user?.first_name) {
      return messageThread.assigned_user.first_name;
    }
    return "AI";
  };

  const formatCreatedAt = (): string => {
    return new Date(messageThread.created_at).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div
      className={`flex items-center gap-x-4 py-4 cursor-pointer ${bordered ? "border-b" : ""}`}
      onClick={() => onClick(messageThread)}
      data-testid={`chat-history-item`}
    >
      <div className="shrink-0">
        {messageThread.assigned_user?.avatar_url ? (
          <img src={messageThread.assigned_user.avatar_url} className="size-[40px] rounded-full" />
        ) : (
          <div className="flex size-[40px] items-center justify-center rounded-full bg-lastbot-icon-muted font-semibold text-lastbot-on-inverse uppercase">
            {formatSenderInitials()}
          </div>
        )}
      </div>
      <div className="flex-1 pt-0.5">
        <div className="text-sm text-lastbot-on-surface">
          {translate("conversation_with", { person_name: formatSenderName() })}
        </div>
        <div className="text-sm text-lastbot-icon-muted">
          {formatSenderName()} &#8226; {formatCreatedAt()}
        </div>
      </div>
      <div className="text-lastbot-on-surface">
        <CaretRightIcon />
      </div>
    </div>
  );
};

export default ChatListItem;
